module.exports = "images/doc-program-print-1.06ef8138a7f4f31f00894568ee8c4801.png";